import {Component, OnChanges, OnInit} from '@angular/core';
import {
    CrCustomerDocumentUploadComponent
} from "../../cr-customer-document-upload/cr-customer-document-upload.component";

// NOT_IN_USE
@Component({
    selector: 'cr-customer-document-upload-consultant',
    templateUrl: './cr-customer-document-upload-consultant.component.html',
    standalone: false
})
export class CrCustomerDocumentUploadConsultantComponent extends CrCustomerDocumentUploadComponent implements OnInit, OnChanges {

ngOnInit() {
    super.ngOnInit();
}
}
